(function () {
  'use strict';

  /*
   * GEÇİCİ REFERANS (çalıştırılmaz): DevTools Console’da cart note’u tamamen silmek için:
   * fetch('/cart/update.js', {
   *   method: 'POST',
   *   headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
   *   body: JSON.stringify({ note: '' })
   * })
   *   .then(function (r) { return r.json(); })
   *   .then(function (cart) { console.log('Cart note temizlendi:', cart.note); location.reload(); })
   *   .catch(function (err) { console.error('Cart note silinemedi:', err); });
   */

  var CORPORATE_INVOICE_DEBUG_CART_JS = false;

  /** Eski sipariş notlarında kalmış marker blokları (bir kez temizlenir) */
  var LEGACY_INVOICE_START = '---EVERLAST_INVOICE---';
  var LEGACY_INVOICE_END = '---END_EVERLAST_INVOICE---';

  /** Programatik checkout submit’ünü submit dinleyicisinden ayırt etmek için */
  var allowCartDrawerFormSubmit = false;

  /** Drawer checkout: disabled kullanma (imleç not-allowed olur); çift tıklamayı kilitle */
  var drawerCheckoutInFlight = false;

  /** Checkbox kaldırıldığında note temizleme isteğini seri hale getirir */
  var checkboxUncheckSyncInFlight = false;

  var NOTE_KEY_COMPANY_TYPE = 'company_type';
  var NOTE_KEY_COMPANY_NAME = 'company_name';
  var NOTE_KEY_TAX_NUMBER = 'tax_number';
  var NOTE_KEY_NAME = 'name';
  var NOTE_KEY_LASTNAME = 'lastname';
  var NOTE_KEY_IDENTITY_NUMBER = 'identity_number';
  var NOTE_VALUE_COMPANY_TYPE_CORPORATE = 'Corporate Company';
  var NOTE_VALUE_COMPANY_TYPE_SOLE = 'Sole proprietorship';

  function fetchConfigSafe() {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };
  }

  function safe(val) {
    return String(val != null ? val : '').replace(/[<>]/g, '');
  }

  function parseJsonResponse(r) {
    if (!r || !r.ok) return Promise.reject(new Error(r ? 'HTTP ' + r.status : 'No response'));
    return r.json();
  }

  function logCartJsIfDebug() {
    if (!CORPORATE_INVOICE_DEBUG_CART_JS || !window.routes || !window.routes.cart_url) return;
    fetch(window.routes.cart_url + '.js')
      .then(parseJsonResponse)
      .then(function (data) {
        console.log('[Shopify cart.js güncel]', data);
      })
      .catch(function (e) {
        console.warn('[cart.js]', e);
      });
  }

  function escapeRegExp(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function parseKeyedInvoiceAt(lines, startIndex) {
    if (!lines || startIndex == null) return null;
    var t = parseLineAfterLabel(lines[startIndex], NOTE_KEY_COMPANY_TYPE + ':');
    if (t == null) return null;
    var company = parseLineAfterLabel(lines[startIndex + 1], NOTE_KEY_COMPANY_NAME + ':');
    var tax = parseLineAfterLabel(lines[startIndex + 2], NOTE_KEY_TAX_NUMBER + ':');
    if (company != null && tax != null) {
      return { kind: 'corporate', length: 3, parsed: { type: 'corporate', company: company, vkn: tax } };
    }
    var first = parseLineAfterLabel(lines[startIndex + 1], NOTE_KEY_NAME + ':');
    var last = parseLineAfterLabel(lines[startIndex + 2], NOTE_KEY_LASTNAME + ':');
    var tckn = parseLineAfterLabel(lines[startIndex + 3], NOTE_KEY_IDENTITY_NUMBER + ':');
    if (first != null && last != null && tckn != null) {
      return { kind: 'individual', length: 4, parsed: { type: 'individual', first: first, last: last, tckn: tckn } };
    }
    return null;
  }

  function stripStructuredInvoiceBlock(note) {
    if (!note) return note;
    var lines = note.split(/\r?\n/);
    var out = [];
    var i = 0;
    while (i < lines.length) {
      var keyedMatch = parseKeyedInvoiceAt(lines, i);
      if (keyedMatch) {
        i += keyedMatch.length;
        while (i < lines.length && lines[i].trim() === '') i++;
        continue;
      }
      out.push(lines[i]);
      i++;
    }
    return out.join('\n').replace(/\n{3,}/g, '\n\n');
  }

  function stripInvoiceBlock(note) {
    if (!note || typeof note !== 'string') return '';
    var cleaned = note;
    var legacy = new RegExp(
      '\\n?' + escapeRegExp(LEGACY_INVOICE_START) + '[\\s\\S]*?' + escapeRegExp(LEGACY_INVOICE_END) + '\\n?',
      'g'
    );
    cleaned = cleaned.replace(legacy, '');
    return stripStructuredInvoiceBlock(cleaned).trim();
  }

  function extractInvoiceInnerBody(note) {
    if (!note || typeof note !== 'string') return null;
    var ls = note.indexOf(LEGACY_INVOICE_START);
    if (ls !== -1) {
      var le = note.indexOf(LEGACY_INVOICE_END, ls + LEGACY_INVOICE_START.length);
      if (le !== -1) {
        return note.slice(ls + LEGACY_INVOICE_START.length, le).replace(/^\n+|\n+$/g, '');
      }
    }
    var lines = note.split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
      var keyedMatch = parseKeyedInvoiceAt(lines, i);
      if (keyedMatch) {
        return lines.slice(i, i + keyedMatch.length).join('\n');
      }
    }
    return null;
  }

  function parseLineAfterLabel(line, label) {
    if (line == null || label == null) return null;
    var t = String(line).trim();
    var l = String(label).trim();
    if (t.indexOf(l) !== 0) return null;
    var rest = t.slice(l.length).trim();
    return rest.length ? rest : null;
  }

  function parseInvoiceInnerBody(body) {
    if (!body) return null;
    var lines = body.split(/\r?\n/);
    var keyedMatch = parseKeyedInvoiceAt(lines, 0);
    if (keyedMatch) return keyedMatch.parsed;
    return null;
  }

  function applyInvoiceToModal(parsed) {
    var modal = getModal();
    if (!modal || !parsed) return;
    var typeSel = modal.querySelector('.js-corporate-invoice-type');
    if (typeSel) typeSel.value = parsed.type;
    if (parsed.type === 'corporate') {
      var c = modal.querySelector('.js-invoice-company');
      var v = modal.querySelector('.js-invoice-vkn');
      if (c) c.value = parsed.company;
      if (v) v.value = parsed.vkn;
    } else {
      var f = modal.querySelector('.js-invoice-first');
      var l = modal.querySelector('.js-invoice-last');
      var t = modal.querySelector('.js-invoice-tckn');
      if (f) f.value = parsed.first;
      if (l) l.value = parsed.last;
      if (t) t.value = parsed.tckn;
    }
    toggleTypeFields();
    updateModalCheckoutDisabled();
  }

  function setCorporateCheckboxChecked(on) {
    var cb = getCorporateCheckbox();
    if (cb) cb.checked = !!on;
  }

  function restoreInvoiceUIFromNote(note) {
    var n = note != null ? String(note) : '';
    var inner = extractInvoiceInnerBody(n);
    if (!inner) {
      setCorporateCheckboxChecked(false);
      return;
    }
    var parsed = parseInvoiceInnerBody(inner);
    if (!parsed) {
      setCorporateCheckboxChecked(false);
      return;
    }
    setCorporateCheckboxChecked(true);
    applyInvoiceToModal(parsed);
  }

  function getRemoveInvoiceWrap() {
    return document.querySelector('.js-corporate-invoice-remove-wrap');
  }

  function syncRemoveInvoiceButtonVisibilityFromNote(note) {
    var wrap = getRemoveInvoiceWrap();
    if (!wrap) return;
    var n = note != null ? String(note) : '';
    var hasSaved = extractInvoiceInnerBody(n) != null;
    wrap.hidden = !hasSaved;
  }

  function syncRemoveInvoiceButtonVisibility() {
    if (!window.routes || !window.routes.cart_url) {
      var w = getRemoveInvoiceWrap();
      if (w) w.hidden = true;
      return;
    }
    fetch(window.routes.cart_url + '.js')
      .then(parseJsonResponse)
      .then(function (cart) {
        var n = cart && cart.note != null ? String(cart.note) : '';
        syncRemoveInvoiceButtonVisibilityFromNote(n);
      })
      .catch(function (err) {
        console.warn('[corporate-invoice] syncRemoveInvoiceButtonVisibility', err);
        var wrap = getRemoveInvoiceWrap();
        if (wrap) wrap.hidden = true;
      });
  }

  function fetchCartNoteAndSyncUi() {
    if (!window.routes || !window.routes.cart_url) return;
    fetch(window.routes.cart_url + '.js')
      .then(parseJsonResponse)
      .then(function (cart) {
        var n = cart && cart.note != null ? String(cart.note) : '';
        setDrawerNoteValue(n);
        restoreInvoiceUIFromNote(n);
        syncRemoveInvoiceButtonVisibilityFromNote(n);
      })
      .catch(function (err) {
        console.error('[corporate-invoice] fetchCartNoteAndSyncUi', err);
      });
  }

  function getBaseNote() {
    var ta = document.getElementById('CartDrawer-Note');
    return ta ? ta.value : '';
  }

  function setDrawerNoteValue(value) {
    var ta = document.getElementById('CartDrawer-Note');
    if (ta) ta.value = value;
  }

  function getCorporateCheckbox() {
    var drawer = document.querySelector('cart-drawer');
    return drawer ? drawer.querySelector('.js-corporate-invoice-checkbox') : null;
  }

  function isCorporateChecked() {
    var cb = getCorporateCheckbox();
    return !!(cb && cb.checked);
  }

  function getModal() {
    return document.getElementById('CorporateInvoice-Modal');
  }

  function ensureModalOnBody() {
    var modal = getModal();
    if (modal && modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
  }

  function closeCartDrawer() {
    var el = document.querySelector('cart-drawer');
    if (el && typeof el.close === 'function') {
      el.close();
    }
  }

  function bindDigitsOnly(el, maxLen) {
    if (!el) return;
    el.addEventListener('input', function () {
      var v = el.value.replace(/\D/g, '');
      if (maxLen) v = v.slice(0, maxLen);
      el.value = v;
      updateModalCheckoutDisabled();
    });
    el.addEventListener('change', updateModalCheckoutDisabled);
  }

  function openModal() {
    ensureModalOnBody();
    var modal = getModal();
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    var sel = modal.querySelector('.js-corporate-invoice-type');
    if (sel) sel.focus();
    syncRemoveInvoiceButtonVisibility();
  }

  function closeModalUi() {
    var modal = getModal();
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  function resetModalForm() {
    var modal = getModal();
    if (!modal) return;
    var form = modal.querySelector('#CorporateInvoice-Form');
    if (form) form.reset();
    var typeSelect = modal.querySelector('.js-corporate-invoice-type');
    if (typeSelect) typeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    updateModalCheckoutDisabled();
  }

  function abandonToHome() {
    resetModalForm();
    closeModalUi();
    var root = (window.corporateInvoiceRootUrl || '/').replace(/\/?$/, '/');
    window.location.href = root;
  }

  function onRemoveSavedInvoiceClick(ev) {
    ev.preventDefault();
    var btn = ev.target.closest && ev.target.closest('.js-corporate-invoice-remove');
    if (!btn || btn.disabled) return;
    var s = window.corporateInvoiceStrings;
    if (!window.routes || !window.routes.cart_url || !window.routes.cart_update_url) return;
    btn.disabled = true;
    fetch(window.routes.cart_url + '.js')
      .then(parseJsonResponse)
      .then(function (cart) {
        var note = cart && cart.note != null ? String(cart.note) : '';
        if (extractInvoiceInnerBody(note) == null) {
          btn.disabled = false;
          syncRemoveInvoiceButtonVisibilityFromNote(note);
          return;
        }
        var newNote = stripInvoiceBlock(note);
        return fetch(
          window.routes.cart_update_url,
          Object.assign({}, fetchConfigSafe(), { body: JSON.stringify({ note: newNote }) })
        ).then(parseJsonResponse);
      })
      .then(function (updated) {
        if (updated === undefined) return;
        setDrawerNoteValue(updated.note !== undefined && updated.note !== null ? updated.note : '');
        setCorporateCheckboxChecked(false);
        resetModalForm();
        closeModalUi();
        var msg = s && s.remove_success ? s.remove_success : '';
        if (msg) alert(msg);
        var root = (window.corporateInvoiceRootUrl || '/').replace(/\/?$/, '/');
        window.location.href = root;
      })
      .catch(function (e) {
        console.error(e);
        btn.disabled = false;
        var err = s && s.error_remove ? s.error_remove : s && s.error_note ? s.error_note : 'Hata';
        alert(err);
      });
  }

  function onInvoiceFieldBlur() {
    clearInvoiceFieldErrors();
    var res = validateModalInvoice();
    if (!res.ok) applyInvoiceFieldErrors(res);
    syncInvoiceFieldSuccessClasses(res);
  }

  function toggleTypeFields() {
    var modal = getModal();
    if (!modal) return;
    clearInvoiceFieldErrors();
    var sel = modal.querySelector('.js-corporate-invoice-type');
    var v = sel ? sel.value : 'corporate';
    modal.querySelectorAll('.corporate-invoice-modal__fields').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-invoice-type') === v);
    });
    updateModalCheckoutDisabled();
  }

  function validateModalInvoice() {
    var modal = getModal();
    if (!modal) return { ok: false, type: null };
    var typeEl = modal.querySelector('.js-corporate-invoice-type');
    var t = typeEl ? typeEl.value : 'corporate';
    var company = safe(((modal.querySelector('.js-invoice-company') || {}).value || '').trim());
    var vkn = ((modal.querySelector('.js-invoice-vkn') || {}).value || '').trim();
    var fn = safe(((modal.querySelector('.js-invoice-first') || {}).value || '').trim());
    var ln = safe(((modal.querySelector('.js-invoice-last') || {}).value || '').trim());
    var tckn = ((modal.querySelector('.js-invoice-tckn') || {}).value || '').trim();
    if (t === 'corporate') {
      var companyOk = company.length > 0;
      var vknOk = /^\d{10}$/.test(vkn);
      return { ok: companyOk && vknOk, type: 'corporate', companyOk: companyOk, vknOk: vknOk };
    }
    var firstOk = fn.length > 0;
    var lastOk = ln.length > 0;
    var tcknOk = /^\d{11}$/.test(tckn);
    return { ok: firstOk && lastOk && tcknOk, type: 'individual', firstOk: firstOk, lastOk: lastOk, tcknOk: tcknOk };
  }

  function formIsValid() {
    return validateModalInvoice().ok;
  }

  function clearInvoiceFieldSuccessClasses(modal) {
    if (!modal) return;
    modal.querySelectorAll('[data-invoice-field]').forEach(function (inp) {
      inp.classList.remove('corporate-invoice-modal__input--success');
    });
  }

  function syncInvoiceFieldSuccessClasses(res) {
    var modal = getModal();
    if (!modal || !res || res.type == null) return;
    clearInvoiceFieldSuccessClasses(modal);
    function addSuccess(key) {
      var inp = modal.querySelector('[data-invoice-field="' + key + '"]');
      if (inp && inp.getAttribute('aria-invalid') !== 'true') {
        inp.classList.add('corporate-invoice-modal__input--success');
      }
    }
    if (res.type === 'corporate') {
      if (res.companyOk) addSuccess('company');
      if (res.vknOk) addSuccess('vkn');
    } else if (res.type === 'individual') {
      if (res.firstOk) addSuccess('first');
      if (res.lastOk) addSuccess('last');
      if (res.tcknOk) addSuccess('tckn');
    }
  }

  function clearInvoiceFieldErrors() {
    var modal = getModal();
    if (!modal) return;
    modal.querySelectorAll('.js-invoice-error-msg').forEach(function (el) {
      el.hidden = true;
      el.textContent = '';
    });
    modal.querySelectorAll('[data-invoice-field]').forEach(function (inp) {
      inp.removeAttribute('aria-invalid');
    });
    clearInvoiceFieldSuccessClasses(modal);
  }

  function setFieldError(modal, key, message) {
    var el = modal.querySelector('[data-invoice-error="' + key + '"]');
    var inp = modal.querySelector('[data-invoice-field="' + key + '"]');
    if (el && message) {
      el.textContent = message;
      el.hidden = false;
    }
    if (inp) {
      inp.setAttribute('aria-invalid', 'true');
      inp.classList.remove('corporate-invoice-modal__input--success');
    }
  }

  function applyInvoiceFieldErrors(res) {
    var s = window.corporateInvoiceStrings;
    if (!s || !res || res.type == null) return;
    var modal = getModal();
    if (!modal) return;
    if (res.type === 'corporate') {
      if (!res.companyOk) setFieldError(modal, 'company', s.validation_error_company);
      if (!res.vknOk) setFieldError(modal, 'vkn', s.validation_error_vkn);
    } else if (res.type === 'individual') {
      if (!res.firstOk) setFieldError(modal, 'first', s.validation_error_first);
      if (!res.lastOk) setFieldError(modal, 'last', s.validation_error_last);
      if (!res.tcknOk) setFieldError(modal, 'tckn', s.validation_error_tckn);
    }
  }

  function refreshInvoiceFieldHints() {
    var res = validateModalInvoice();
    if (res.ok) clearInvoiceFieldErrors();
    syncInvoiceFieldSuccessClasses(res);
  }

  function updateModalCheckoutDisabled() {
    var modal = getModal();
    if (!modal) return;
    var btn = modal.querySelector('.js-corporate-invoice-modal-checkout');
    if (btn) btn.disabled = !formIsValid();
    refreshInvoiceFieldHints();
  }

  function buildInvoiceNoteText() {
    var s = window.corporateInvoiceStrings;
    if (!s) return '';
    var modal = getModal();
    if (!modal) return '';
    var t = (modal.querySelector('.js-corporate-invoice-type') || {}).value;
    if (t === 'individual') {
      var fn = safe(((modal.querySelector('.js-invoice-first') || {}).value || '').trim());
      var ln = safe(((modal.querySelector('.js-invoice-last') || {}).value || '').trim());
      var tckn = ((modal.querySelector('.js-invoice-tckn') || {}).value || '').trim().replace(/\D/g, '');
      return (
        NOTE_KEY_COMPANY_TYPE +
        ': ' +
        NOTE_VALUE_COMPANY_TYPE_SOLE +
        '\n' +
        NOTE_KEY_NAME +
        ': ' +
        fn +
        '\n' +
        NOTE_KEY_LASTNAME +
        ': ' +
        ln +
        '\n' +
        NOTE_KEY_IDENTITY_NUMBER +
        ': ' +
        tckn
      );
    }
    var company = safe(((modal.querySelector('.js-invoice-company') || {}).value || '').trim());
    var vkn = ((modal.querySelector('.js-invoice-vkn') || {}).value || '').trim().replace(/\D/g, '');
    return (
      NOTE_KEY_COMPANY_TYPE +
      ': ' +
      NOTE_VALUE_COMPANY_TYPE_CORPORATE +
      '\n' +
      NOTE_KEY_COMPANY_NAME +
      ': ' +
      company +
      '\n' +
      NOTE_KEY_TAX_NUMBER +
      ': ' +
      vkn
    );
  }

  function mergeNote(invoiceBody) {
    var base = stripInvoiceBlock(getBaseNote());
    if (!base) return invoiceBody;
    return base + '\n\n' + invoiceBody;
  }

  function submitNoteAndGoCheckout(finalNote) {
    var modalBtn = getModal() ? getModal().querySelector('.js-corporate-invoice-modal-checkout') : null;
    fetch(window.routes.cart_update_url, Object.assign({}, fetchConfigSafe(), { body: JSON.stringify({ note: finalNote }) }))
      .then(parseJsonResponse)
      .then(function (cart) {
        setDrawerNoteValue(cart && cart.note !== undefined ? cart.note : finalNote);
        window.location.href = window.corporateInvoiceCheckoutUrl || '/checkout';
      })
      .catch(function (e) {
        console.error('[corporate-invoice] cart/update (checkout)', e);
        if (modalBtn) modalBtn.disabled = false;
        openModal();
        var s = window.corporateInvoiceStrings;
        var msg = s && s.error_note ? s.error_note : 'Hata';
        if (s && e && String(e.message || '').indexOf('HTTP') === 0 && s.error_network) msg = s.error_network;
        alert(msg);
      });
  }

  function onModalCheckoutClick(e) {
    e.preventDefault();
    var btn = e.target && e.target.closest && e.target.closest('.js-corporate-invoice-modal-checkout');
    if (!btn || btn.disabled) return;
    clearInvoiceFieldErrors();
    var res = validateModalInvoice();
    if (!res.ok) {
      applyInvoiceFieldErrors(res);
      syncInvoiceFieldSuccessClasses(res);
      return;
    }
    btn.disabled = true;
    var invoiceBody = buildInvoiceNoteText();
    var finalNote = mergeNote(invoiceBody);
    closeModalUi();
    submitNoteAndGoCheckout(finalNote);
  }

  function doSubmitCartDrawerCheckoutForm() {
    var form = document.getElementById('CartDrawer-Form');
    if (!form) return;
    allowCartDrawerFormSubmit = true;
    var submitter = document.createElement('button');
    submitter.type = 'submit';
    submitter.name = 'checkout';
    submitter.hidden = true;
    form.appendChild(submitter);
    submitter.click();
    form.removeChild(submitter);
  }

  /**
   * Kurumsal fatura kutusu kapalıyken checkout: sepet notundan yalnızca fatura blokunu kaldırır
   * (diğer sipariş notu metnine dokunmaz), sonra formu gönderir.
   */
  function submitDrawerCartForCheckout() {
    if (isCorporateChecked()) return;
    if (drawerCheckoutInFlight) return;
    var drawerBtn = document.getElementById('CartDrawer-Checkout');
    if (drawerBtn && drawerBtn.disabled) return;

    function releaseDrawerCheckoutLock() {
      drawerCheckoutInFlight = false;
    }

    drawerCheckoutInFlight = true;

    if (!window.routes || !window.routes.cart_url || !window.routes.cart_update_url) {
      doSubmitCartDrawerCheckoutForm();
      releaseDrawerCheckoutLock();
      return;
    }
    fetch(window.routes.cart_url + '.js')
      .then(parseJsonResponse)
      .then(function (cart) {
        var note = cart && cart.note != null ? String(cart.note) : '';
        var stripped = stripInvoiceBlock(note);
        if (stripped === note) {
          return Promise.resolve();
        }
        return fetch(
          window.routes.cart_update_url,
          Object.assign({}, fetchConfigSafe(), { body: JSON.stringify({ note: stripped }) })
        )
          .then(parseJsonResponse)
          .then(function (updated) {
            setDrawerNoteValue(
              updated && updated.note !== undefined && updated.note !== null ? updated.note : stripped
            );
          });
      })
      .then(function () {
        doSubmitCartDrawerCheckoutForm();
      })
      .catch(function (e) {
        console.error('[corporate-invoice] drawer checkout strip', e);
        releaseDrawerCheckoutLock();
        doSubmitCartDrawerCheckoutForm();
      });
  }

  function onCartDrawerFormSubmit(e) {
    var form = e.target;
    if (!form || form.id !== 'CartDrawer-Form') return;
    if (allowCartDrawerFormSubmit) {
      allowCartDrawerFormSubmit = false;
      return;
    }
    if (isCorporateChecked()) {
      e.preventDefault();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      e.stopPropagation();
      closeCartDrawer();
      window.setTimeout(function () {
        openModal();
      }, 200);
      return;
    }
    var sub = e.submitter;
    if (sub && sub.name === 'checkout') {
      e.preventDefault();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      e.stopPropagation();
      submitDrawerCartForCheckout();
    }
  }

  function onDrawerCheckoutClick(e) {
    var btn = e.target.closest && e.target.closest('#CartDrawer-Checkout');
    if (!btn) return;
    if (btn.disabled) return;
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    e.stopPropagation();
    if (isCorporateChecked()) {
      closeCartDrawer();
      window.setTimeout(function () {
        openModal();
      }, 200);
      return;
    }
    submitDrawerCartForCheckout();
  }

  function onCorporateCheckboxChange(e) {
    var cb = e.target;
    if (!cb || !cb.classList || !cb.classList.contains('js-corporate-invoice-checkbox')) return;
    if (cb.checked) return;
    if (checkboxUncheckSyncInFlight) return;
    if (!window.routes || !window.routes.cart_url || !window.routes.cart_update_url) return;

    checkboxUncheckSyncInFlight = true;
    fetch(window.routes.cart_url + '.js')
      .then(parseJsonResponse)
      .then(function (cart) {
        var note = cart && cart.note != null ? String(cart.note) : '';
        var stripped = stripInvoiceBlock(note);
        if (stripped === note) {
          setDrawerNoteValue(note);
          syncRemoveInvoiceButtonVisibilityFromNote(note);
          return null;
        }
        return fetch(
          window.routes.cart_update_url,
          Object.assign({}, fetchConfigSafe(), { body: JSON.stringify({ note: stripped }) })
        )
          .then(parseJsonResponse)
          .then(function (updated) {
            var newNote = updated && updated.note != null ? String(updated.note) : stripped;
            setDrawerNoteValue(newNote);
            syncRemoveInvoiceButtonVisibilityFromNote(newNote);
            return updated;
          });
      })
      .catch(function (err) {
        console.error('[corporate-invoice] checkbox uncheck strip', err);
      })
      .then(function () {
        checkboxUncheckSyncInFlight = false;
      });
  }

  function initModalListeners() {
    var modal = getModal();
    if (!modal) return;

    var typeSel = modal.querySelector('.js-corporate-invoice-type');
    if (typeSel) typeSel.addEventListener('change', toggleTypeFields);

    modal.querySelectorAll('.js-invoice-company, .js-invoice-first, .js-invoice-last').forEach(function (el) {
      el.addEventListener('input', updateModalCheckoutDisabled);
      el.addEventListener('change', updateModalCheckoutDisabled);
    });

    modal.querySelectorAll('[data-invoice-field]').forEach(function (el) {
      el.addEventListener('blur', onInvoiceFieldBlur);
    });

    bindDigitsOnly(modal.querySelector('.js-invoice-vkn'), 10);
    bindDigitsOnly(modal.querySelector('.js-invoice-tckn'), 11);

    var checkoutBtn = modal.querySelector('.js-corporate-invoice-modal-checkout');
    if (checkoutBtn) checkoutBtn.addEventListener('click', onModalCheckoutClick);

    modal.querySelectorAll('.js-corporate-invoice-abandon').forEach(function (homeBtn) {
      homeBtn.addEventListener('click', function (ev) {
        ev.preventDefault();
        abandonToHome();
      });
    });

    var backdrop = modal.querySelector('.js-corporate-invoice-backdrop');
    if (backdrop) {
      backdrop.addEventListener('click', function (ev) {
        ev.preventDefault();
        abandonToHome();
      });
    }

    var removeBtn = modal.querySelector('.js-corporate-invoice-remove');
    if (removeBtn) removeBtn.addEventListener('click', onRemoveSavedInvoiceClick);

    toggleTypeFields();
  }

  function init() {
    ensureModalOnBody();
    logCartJsIfDebug();
    document.addEventListener('click', onDrawerCheckoutClick, true);
    document.addEventListener('submit', onCartDrawerFormSubmit, true);
    document.addEventListener('change', onCorporateCheckboxChange, true);
    initModalListeners();
    restoreInvoiceUIFromNote(getBaseNote());
    syncRemoveInvoiceButtonVisibilityFromNote(getBaseNote());
    fetchCartNoteAndSyncUi();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
